<script lang="ts">
  import { paramsService, procedencesService } from '../services';
  import type { Param } from '../Model/Param';
  import type { Procedence } from '../Model/Procedence';

  export let procedenceAntecedentSelectId: string;
  export let procedenceAntecedentSelectName: string = '';

  let procedences: Procedence[];
  let procedencesShow: Procedence[] = [];
  let params: Param[];


  load();

  async function load() {

    params = await paramsService.findByType('modules');
    procedences = await procedencesService.find();

    const paramSelect = params.find(p => p.name == 'Registro de Antecedentes Externos');

    if (!paramSelect) {
      return;
    }

    for (const procedence of procedences) {
      if (procedence.moduleId == paramSelect.id) {
        procedencesShow.push(procedence)
      }
    }

    procedencesShow.sort((a, b) => {
      return a.name < b.name ? -1 : 1;
    });

    procedencesShow = procedencesShow;
  }

  function actName(e: any) {
    let [procedence] = procedencesShow.filter(p => p.id == e.srcElement.value)
    procedenceAntecedentSelectName = procedence.name;
  }

</script>

{#if procedencesShow}
  <div class="input-group">
    <select class="form-select" bind:value={procedenceAntecedentSelectId} on:change={actName}>
      {#each procedencesShow as procedence}
        <option value={procedence.id}>{procedence.name}</option>
      {/each}
    </select>
  </div>
{/if}

<style>
</style>
